import { List } from "antd";
import { OpForm } from "components/customAntd/DLS/OpForm/OpForm";
import { useTranslation } from "react-i18next";

const OptionsForm: React.FC = () => {
    const { t } = useTranslation();
    return (
        <List
            header={t("user.form.optionsTitle")}
            dataSource={[
                { name: 'hostExclude', label: t('user.form.excludeAsHost') }
            ]}
            bordered
            renderItem={item => (
                <List.Item>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <OpForm.Switch name={item.name} data-testid={`switch-${item.name}`} />
                        <span style={{ marginLeft: 8 }}>{item.label}</span>
                    </div>
                </List.Item>
            )}
        />
    );
};

export default OptionsForm;
